import { createFileRoute, redirect } from '@tanstack/react-router'
import { DocsLayout } from '@/components/docs/DocsLayout'

export const Route = createFileRoute('/$lang/docs')({
  staticData: {
    langs: ['en'],
  },
  beforeLoad: ({ params }) => {
    if (params.lang !== 'en') {
      throw redirect({ to: '/$lang/docs/', params: { lang: 'en' }, replace: true })
    }
  },
  component: DocsLayout,
})
